import React from 'react';

export const SsoLoginLogo = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} {...props}>
        <path d="m15.494 14.62-4.375 4.374a.875.875 0 0 1-1.238-1.238l2.882-2.881H2.625a.875.875 0 0 1 0-1.75h10.138l-2.882-2.88a.876.876 0 0 1 1.238-1.24l4.375 4.376a.876.876 0 0 1 0 1.238ZM21.875 3.5h-7a.875.875 0 1 0 0 1.75H21v17.5h-6.125a.875.875 0 1 0 0 1.75h7a.875.875 0 0 0 .875-.875V4.375a.875.875 0 0 0-.875-.875Z" />
    </svg>
);
